class CommentSectionController {
  /* @ngInject */
  constructor($http, $stateParams, $state, Session, moment, urls) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.Session = Session;
    this.moment = moment;
    this.states = Session.read('states');
    this.urls = urls;
  }

  $onInit() {
    this.user = this.Session.read('userinfo') || {};
    this.isVendor = this.user.client.type === 'VENDOR';
    this.ui = { scrollToBottom: false };
    this.caseId = this.case.id;
    this.getComments();
    this.data = {
      tatAction: (this.case.tatActivity && this.case.tatActivity.tat_action === 'Start')
        ? 'Stop' : 'Start',
    };
  }

  getComments() {
    this.$http.get('/case/comment', { params: { caseId: this.caseId } })
      .then(({ data }) => {
        this.comments = data;
        this.ui.scrollToBottom = true;
      });
  }

  submit(form) {
    if (form.$invalid || this.submitting) return;

    this.submitting = true;
    this.$http.post(`/case/${this.$stateParams.id}/comment`, {
      comment: this.comment,
    })
      .then(() => {
        this.submitting = false;
        this.ui.scrollToBottom = false;
        this.comment = undefined;
        this.getComments();
      })
      .catch(() => (this.submitting = false));
  }

  toggleTat(caseStateId) {
    this.$http.post(`/case/${this.$stateParams.id}/state/${caseStateId}/tat`, {
      tatAction: this.data.tatAction,
    })
      .then(() => {
        this.$state.reload();
      });
  }

  getStateAttachmentLink(comment) {
    return `${this.urls.API_SERVER}/api/case/casestate/${
      comment.id}/attachment?access_token=${this.Session.accessToken}`;
  }
}

export default CommentSectionController;



// WEBPACK FOOTER //
// ./client/components/comment-section/comment-section.controller.js